export const Collections = {
  tickets: 'tickets',
  ticketTypes: 'ticketTypes',
  mails: 'mails',
  payments: 'payments',
  mailTemplates: 'mail_templates',
};

export type Ticket = {
  ticketId: string;
  name: string;
  email: string;
  ticketType: {
    label: string;
    name: string;
    price: number;
  };
  price: number;
  createdAt: string;
  paymentId: string | null;
  paidAt: string | null;
  canceledAt?: string | null;
  paymentReminderSentAt?: string | null;
  checkinAt?: string | null;
};

export type Payment = {
  paymentId: string;
  ticketId: string;
  createdAt: string;
  stripe: any;
};

export type TicketType = {
  name: string;
  label: string;
  contingent: number;
  available: number;
  price: number;
};
